function copyURI(evt) {
	evt.preventDefault();
	const copyButton = evt.currentTarget;
	const urlToCopy = window.location.href;
	const nameSpan = copyButton.querySelector('.share-button__name');
	const originalText = nameSpan ? nameSpan.textContent.trim() : '';
	
	navigator.clipboard.writeText(urlToCopy).then(() => {
		if (nameSpan) {
			nameSpan.textContent = 'Copiado';
			setTimeout(() => {
				nameSpan.textContent = originalText;
			}, 2000);
		}
	});
}

const copyLinks = document.querySelectorAll('.copy-btn');
for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI);
}
